import { GraphQLOnboardingChecklistRequester } from '@cobliteam/api-lib';
import { useMutation, useQuery } from '@tanstack/react-query';

const graphQLOnboardingChecklistRequester = new GraphQLOnboardingChecklistRequester();

const useOnboardingChecklist = () =>
  useQuery({
    queryKey: ['onboardingChecklist'],
    queryFn: () => graphQLOnboardingChecklistRequester.getOnboardingChecklist(),
  });

const useUpdateOnboardingChecklist = () =>
  useMutation({
    mutationFn: ({ id, finished }: { id: string; finished: boolean }) => graphQLOnboardingChecklistRequester.updateOnboardingChecklist(id, finished),
  });

export { useOnboardingChecklist, useUpdateOnboardingChecklist };
